import type { Team } from '../../api/teams'

export function canViewTeamCredits(team: Team | null | undefined): boolean {
  return team?.myRole === 'owner' || team?.myRole === 'admin'
}

/** Prepaid members may open a statement showing an access note; financial reads stay gated. */
export function canOpenCreditStatement(team: Team | null | undefined, allowAccessNote = true): boolean {
  return canViewTeamCredits(team) || (allowAccessNote && team?.creditBillingMode !== 'postpaid')
}
